Ext.define('SA.view.sidebar.data.DataSearchConditionsOverflowMenuButton', {
    alias: 'widget.data-search-conditions-overflow-menu-button',
    extend: 'SA.view.MenuButton',

    cls: 'sa-data-search-conditions-overflow-menu-btn',
    menuAlign: 'tc-bc?',

    initComponent() {
        this.menu = {
            xtype: 'component',
            cls: 'sa-data-search-conditions-overflow',
            floating: true,

            listeners: {
                el: {
                    delegate: '.sa-data-search-condition-remove-wrap',

                    click: ev => {
                        this.fireEvent('click:removeCondition', ev);
                    }
                }
            },

            plugins: [{
                ptype: 'close-on-click-outside',

                onDocMouseDown: (ev, el) => {
                    var menu = this.getMenu();

                    if (menu.el.dom.contains(el)) {
                        return;
                    }

                    menu.hide();
                }
            }]
        };

        this.callParent();
    },

    afterRender() {
        this.callParent();

        this.getMenu().getPlugin('sa-arrow').setTarget(this.el);
    },

    onResize() {
        this.menu.hide();
    },

    setConditions(conditions) {
        var menu = this.getMenu();

        if (!conditions.length) {
            menu.hide();
        }

        menu.update(conditions);

        if (!menu.isHidden()) {
            this.showMenu();

            menu.getPlugin('sa-arrow').refresh();
        }
    },

    setConditionsTpl(conditionsTpl) {
        this.menu.tpl = '<div class="sa-data-search-conditions-overflow-conditions-wrap">' + conditionsTpl + '</div>';
    },

    showMenu() {
        var bodyHeight = this.up('data-search-window').getBodyHeight();

        this.getMenu().maxHeight = Math.max(bodyHeight - 50, 175);

        this.callParent();
    }
});
